// eslint-disable-next-line
export default {
  GetToken() {
    return `/customer/signin`;
  },

  Login() {
    return `/customer/login`;
  },
  Register() {
    return `/customer/register`;
  },
  DepartureTerminals() {
    return `/Terminal?AvialableOnLine=1000&Paginated=false`;
  },
  ArrivalTerminals(departureTerminalId) {
    return `/Terminal/GetDestinationTerminals/${departureTerminalId}`;  },
  BookingSearch() {
    return `/Booking/availabletripdetails`;
  },
  PostSearch() {
    return `/booking`;
  },
  HireSearchOneway(
    OnewayPickupDate,
    OnewayDistanceApart,
    OneWayDropoffLocation,
    OnewayPickupLocation
  ) {
    return `/HireBooking/bookingSearch?OnewayPickupDate=${OnewayPickupDate}&OnewayDistanceApart=${OnewayDistanceApart}&OneWayDropoffLocation=${OneWayDropoffLocation}&HiredServiceType=0&OnewayPickupLocation=${OnewayPickupLocation}&IsSleepOver=false`;
    // return `/api/hiredServiceBookings/hireservicebookingsearch`;
  },
  HireSearch(
    OnewayPickupDate,
    OnewayDistanceApart,
    OneWayDropoffLocation,
    OnewayPickupLocation,
    ReturnPickupDate = null,
    ReturnPickupLocation = null,
    ReturnDropoffLocation = null
  ) {
    return `/HireBooking/bookingSearch?OnewayPickupDate=${OnewayPickupDate}&OnewayDistanceApart=${OnewayDistanceApart}&OneWayDropoffLocation=${OneWayDropoffLocation}&HiredServiceType=0&OnewayPickupLocation=${OnewayPickupLocation}&IsSleepOver=false&ReturnPickupDate=${ReturnPickupDate}&ReturnPickupLocation=${ReturnPickupLocation}&ReturnDropoffLocation=${ReturnDropoffLocation}`;
    // return `/api/hiredServiceBookings/hireservicebookingsearch`;
  },
  HireServiceSearch() {
    return `/HireBooking/requestBooking`;
  },
  ConfirmPayStackPayment(refCode) {
    return `/Payment/ProcessPaystackPayment/${refCode}`;
  },
  ConfirmFlutterPayment(refCode) {
    return `/Payment/ProcessFlutterWavePayment/${refCode}`;
  },
  ConfirmBudPayPayment(refCode) {
    return `/Payment/ProcessBudPayPayment/${refCode}`;
  },
  ConfirmAzaPayPayment() {
    return `/api/Webhook/ValidateAzaPayTransaction`;
  },
  ConfirmHirePayStackPayment(refCode) {
    return `/Payment/ProcessHiredServicePaystackPayment/${refCode}`;
  },
  ForgotPassword() {
    return `/api/customers/ForgotPasswordVerificationCode`;
  },
  ResetPassword() {
    return `/customer/newpassword`;
  },
  SendOtp() {
    return `/customer/sendotp`;
  },
  VerifyOtp() {
    return `/customer/verifyotp`;
  },
  UpdatePhoto() {
    return `/customer/updatephoto`;
  },
  UpdatePassegerProfile() {
    return `/customer/Update`;
  },
  DeletePhoto(customerId) {
    return `/api/customers/removeCustomerPhoto/${customerId}`;
  },
  GetWalletToken() {
    return `/connect/token`;
  },
  CreateWallet() {
    return `/api/v3/WalletApi/CreateWallet?walletType=3`;
  },
  GetWallet(phone, email) {
    return `/api/v3/WalletApi/GetUserWallet/${phone}/${email}`;
  },
  CreatePartnerStellersAcct() {
    return `/api/v3/WalletApi/UpdateBankRequirement`;
  },
  GenerateOtp() {
    return `/api/v2/WalletApi/GenerateOtp`;
  },
  CreatePin() {
    return `/api/v2/WalletApi/CreatePin`;
  },
  CreatePayment() {
    return `/api/PaymentApi/CreatePayment`;
  },
  VerifyPayStackRef(paystackreference) {
    return `/api/PaymentApi/VerifyPaystackRef/${paystackreference}`;
  },
  DebitWallet() {
    return `/api/v2/WalletApi/DebitWallet`;
  },
  BookingHistory(phoneNumber) {
    return `/Booking/historyByPhonenumber?Phonenumber${phoneNumber}`;
  },
  ChangePassword() {
    return `/customer/ChangePassword`;
  },

  ChangeWalletpin() {
    return `/api/v2/WalletApi/ChangePin`;
  },
  ResetWalletpin() {
    return `/api/v2/WalletApi/ResetPin`;
  },
  CustomerFeedback() {
    return `/api/CustomerFeedbacks`;
  },
  BookingStatus(refCode) {
    return `/Booking/${refCode}`;
  },
  SuggestRoute() {
    return `/route/addnewsuggestedroute`;
  },
  GetpopularRoute() {
    return `/route/getpopularroutes?noOfDays=5&noOfRoutes=5`;
  },
  TrackVehicleById(imei) {
    return `/AutoTrack/vehicletrip?vehicleImei=${imei}`;
  },
  SavePartnerEnquiry() {
    return `/PartnerEnquiry`;
  },
  GetTerminalById(terminalId) {
    return `/terminal/${terminalId}`;
  },
  GetAllPaymentGateways() {
    return `/PaymentGateway?PageNumber=1&PageSize=20`;
  },
  CheckPassengerIn(refCode, terminalId) {
    return `/SeatManagement/getseatSelf/refcode/${refCode}/${terminalId}`;
  },
  ProcessWallet() {
    return `/Payment/ProcessWalletPayment`;
  },
  GetDistance(departureAddress, arrivalAddress) {
    return `/HireBooking/getDistance?depart=${departureAddress}&arrival=${arrivalAddress}`;
    // return `/api/booking/hiredbookings/getDistance?depart=${departureAddress}&arrival=${arrivalAddress}`;
  },
  GetNewToken(oldToken) {
    return `/Customer/generatenewtoken?token=${oldToken}`;
  },

};